import { useLocationQuery } from "./utilHooks";

export function useCheckoutQueryParams() {
    const query = useLocationQuery();

    const sessionId = query.get("session_id");
    const checkoutParam = query.get("checkout_success");
    const isCheckoutSuccess = checkoutParam === "true";

    return { isCheckoutSuccess, sessionId };
}
